import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface TemporaryAccessExchangeResponse {
  access_token: string;
  expires_in: number;
  token_type: 'bearer' | string;
}

@Injectable({ providedIn: 'root' })
export class TemporaryAccessApiService {
  constructor(private http: HttpClient) {}

  exchangeCode(code: string): Observable<TemporaryAccessExchangeResponse> {
    const url = `${environment.apiBaseUrl_identity}identity/temporary-access/exchange`;
    const body = new HttpParams().set('code', code).toString();
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.post<TemporaryAccessExchangeResponse>(url, body, { headers });
  }
}
